import http from "./http";
import { buildUrlFromLocation } from "@/utils/httpUtils";
import httpService from "../components/service";

export default {
    async get(id) {
        return await http.get(buildUrlFromLocation("/cf/period-has-zones/" + id, { campaignId: null }));
    },
    async put(id, quantities, type) {
        return await http.put(buildUrlFromLocation("/cf/period-has-zones/" + id + "?type=" + type, { campaignId: null }), quantities);
    },
    async checkDownloadXls(id) {
        return await http.get(buildUrlFromLocation(`/cf/period-has-zones/${id}/check-download-xls`, { campaignId: null }));
    },
    async downloadXls(id) {
        return await http.get(buildUrlFromLocation(`/cf/period-has-zones/${id}/download-xls`, { campaignId: null }));
    },
    async checkUploadXls(id) {
        return await http.get(buildUrlFromLocation(`/cf/period-has-zones/${id}/check-upload-xls`, { campaignId: null }));
    },
    uploadXls(id, file) {
        const formData = new FormData();
        formData.append("file", file);
        return httpService.fetch("UPLOAD", `/cf/period-has-zones/${id}/upload-xls`, formData, false, false, false, {}, true);
    },
    async getAllForMarket(zoneId) {
        return await http.get(buildUrlFromLocation("/cf/period-has-zones/market/" + zoneId, { campaignId: null }));
    }
};



// WEBPACK FOOTER //
// ./src/services/cfPeriodHasZones.js